<div class="page-transition">
    <div class="page-transition-outer"></div>
    <div class="page-transition-inner"></div>
</div>